// apps/client/src/ui/screens/update.tsx (M0-T18, revision 9 item 1) — the phase screen for `updateRequired`: the server told this
// client its protocol is too old (spec §7.2 "older clients are told to update"). Needs no store data, so it shows even when the
// socket stopped before any snapshot.
import { useT } from '../i18n';
import { Button, Panel } from '../kit';
import type { ScreenDef } from '../router';

declare module '../router' { interface ScreenParams { update: undefined } }

function Update() {
  const t = useT();
  return (
    <div className="layer-full hit" style={{ display: 'grid', placeItems: 'center' }}>
      <div style={{ display: 'grid', justifyItems: 'center', gap: 28 }}>
        <h1 style={{ fontWeight: 900, fontSize: 'clamp(54px, 6.6vw, 94px)', letterSpacing: '-0.025em', margin: 0, textShadow: '0 .045em .09em rgba(74,58,44,.2)' }}>
          {t('common.appName')}
        </h1>
        <Panel>
          <div style={{ display: 'grid', justifyItems: 'center', gap: 18, textAlign: 'center' }}>
            <p style={{ margin: 0, fontWeight: 800, fontSize: 19 }}>{t('hud.updateRequired', { app: t('common.appName') })}</p>
            <Button onClick={() => window.location.reload()}>{t('hud.reload')}</Button>
          </div>
        </Panel>
      </div>
    </div>
  );
}
export const screen: ScreenDef<'update'> = { id: 'update', layer: 'full', component: Update };
